// docs: https://github.com/altostra/type-validations#readme
import { anyOf, objectOf } from "@altostra/type-validations";
import { boolean, nullOrUndefined, number, string } from "@altostra/type-validations/lib/primitives";

export const isPostCustomObjectsObjectRelationshipTypeFieldsResult = objectOf({
  name: string,
  display_label: anyOf(nullOrUndefined, string),
  data_type: anyOf(nullOrUndefined, string),
  required: anyOf(nullOrUndefined, boolean),
  position: anyOf(nullOrUndefined, number),
});
